import $ from 'jquery';
import { CLASS_NAME_LOADING } from 'util/constants';
import { $window, jqCreateElem, jqGetElemById, isMobile, setScrollPosition } from 'util/global';
import Raven from 'util/raven';
import { Anchors } from 'util/ui';
import { showTimeoutErrorModal, errorModalHandler } from 'app/error_modal';
import 'lib/bootstrap';

/** @module */
const account = {};

// email account settings page
// --------------------------------------------------


/**
 * Controller.
 * @param {JQuery} $container
 */
account.emailAddresses = ($container) => {
    const $btnsVerify = $container.find('.verify');
    const $btnsPrimary = $container.find('.make-primary');
    const $btnsRemove = $container.find('.remove');
    const $submitBtnVerify = $container.find('[name=action_send]');
    const $submitBtnPrimary = $container.find('[name=action_primary]');
    const $submitBtnRemove = $container.find('[name=action_remove]');
    const $addEmailLink = $container.find('.add-email-link');
    const $addEmailForm = $container.find('.add-email-form');

    /**
     * @param {JQuery} $visibleBtns
     * @param {JQuery} $submitBtn
     */
    const linkBtns = ($visibleBtns, $submitBtn) => {
        $visibleBtns.on('click', (e) => {
            e.preventDefault();
            $(e.currentTarget).parents('li').find('input[type=radio]').prop('checked', true);
            $submitBtn.click();
        });
    };

    linkBtns($btnsVerify, $submitBtnVerify);
    linkBtns($btnsPrimary, $submitBtnPrimary);
    linkBtns($btnsRemove, $submitBtnRemove);

    $submitBtnRemove.on('click', () => {
        const email = $container.find('input[type=radio]:checked').val();
        // eslint-disable-next-line
        return confirm(`Do you really want to remove ${email}?`);
    });

    $addEmailLink.on('click', (e) => {
        e.preventDefault();
        $(e.currentTarget).parents('tr').hide();
        $addEmailForm.removeClass('hide').find('input').focus();
        $addEmailLink.addClass('hide');
    });

    if ($addEmailForm.find('.errorlist').length > 0) {
        $addEmailLink.click();
    }
};


/**
 * Controller.
 * @param {JQuery} $container
 */
account.emailSettings = ($container) => {
    const RETRY_LIMIT = 5;

    /**
     * Tracks request timeouts.
     * @param {string} result
     */
    const trackTimeout = (result) => {
        Raven.captureMessage('email settings timeout error: ' + result);
    };

    $container.find('form').each((i, form) => {
        const $form = $(form);
        const $checkboxes = $form.find('input.unsubscribe');

        $checkboxes.each((j, checkbox) => {
            const $checkbox = $(checkbox);
            let isSending = false;

            $checkbox.on('click', () => {
                // prevent multiple requests
                if (isSending) {
                    return;
                }

                isSending = true;

                let url = $form.attr('action');
                let retryCount = 0;
                const isChecked = $checkbox.prop('checked');
                const opts = {
                    type: 'POST',
                    timeout: 3000, // 3s
                };

                url = url.replace(/\/(un)?checked\//, isChecked ? '/checked/' : '/unchecked/');
                opts.url = url;

                // disable the checkbox
                $checkbox.prop('disabled', true);

                /** Reverts the form after an error so the user can try again. */
                const revertForm = () => {
                    isSending = false;
                    $checkbox.prop('disabled', false);
                    $checkbox.prop('checked', !isChecked);
                };

                /** Sends the request. */
                const sendRequest = () => {
                    $.ajax(opts)
                        .then(() => {
                            // show "saved" message
                            isSending = false;
                            $form.removeClass('opt-out');
                            $checkbox.prop('disabled', false);
                            if (isChecked) {
                                let type = 'email';
                                if ($form.hasClass('push_notif')) {
                                    type = 'push_notif';
                                }
                                // if we are checking the global unsubscribe, uncheck the others
                                if ($form.hasClass('global_unsubscribe')) {
                                    const checkboxesToDisable = $container.find(`form.${type}:not(.global_unsubscribe) input[type=checkbox]:checked`);
                                    checkboxesToDisable.trigger('click');
                                } else { // if we are checking one of the others, uncheck the global
                                    const globalChecked = $container.find(`form.${type}.global_unsubscribe input[type=checkbox]:checked`)
                                    if (globalChecked.length > 0 ) {
                                        globalChecked.trigger('click');
                                    }
                                }
                            }
                        })
                        .fail((xhr, status) => {
                            // if timeout, try resending until success or reaching the retry limit
                            if (status === 'timeout') {
                                if (retryCount < RETRY_LIMIT) {
                                    retryCount++;
                                    trackTimeout('retry');
                                    sendRequest();
                                } else {
                                    showTimeoutErrorModal();
                                    trackTimeout('limit reached');
                                    revertForm();
                                }
                            // other errors (404, 500, etc), show the normal error modal
                            } else {
                                errorModalHandler(xhr);
                                revertForm();
                            }
                        });
                };
                sendRequest();
            });
        });
    });

    // scroll to the target checkbox if necessary

    const $optoutField = $('.opt-out');

    if ($optoutField.length > 0) {
        let $tableRows = $optoutField.parents('.pref-group-row');
        if (isMobile) {
            $tableRows = $tableRows.add($tableRows.prev('.pref-group-row'));
        }
        $tableRows.addClass('highlighted');
        setScrollPosition($optoutField.offset().top - ($window.height() / 2), {
            animate: true,
        });
        setTimeout(() => {
            $tableRows.addClass('transition').removeClass('highlighted');
        }, 5000);
    }
};

/**
 * Controller.
 * @param {JQuery} $container
 */
account.soundEffects = ($container) => {
  const RETRY_LIMIT = 5;

  /**
   * Tracks request timeouts.
   * @param {string} result
   */
  const trackTimeout = (result) => {
    Raven.captureMessage('sound preferences timeout error: ' + result);
  };

  $container.find('form').each((i, form) => {
    const $form = $(form);
    const $checkboxes = $form.find('input.preferences');

    $checkboxes.each((j, checkbox) => {
      const $checkbox = $(checkbox);
      let isSending = false;

      $checkbox.on('click', () => {
        // prevent multiple requests
        if (isSending) {
          return;
        }

        isSending = true;

        let url = $form.attr('action');
        let retryCount = 0;
        const isChecked = $checkbox.prop('checked');
        const opts = {
          type: 'POST',
          timeout: 3000, // 3s
        };

        url = url.replace(/\/(un)?set_flag\//, isChecked
            ? '/set_flag/'
            : '/unset_flag/');
        opts.url = url;

        // disable the checkbox
        $checkbox.prop('disabled', true);

        /** Reverts the form after an error so the user can try again. */
        const revertForm = () => {
          isSending = false;
          $checkbox.prop('disabled', false);
          $checkbox.prop('checked', !isChecked);
        };

        /** Sends the request. */
        const sendRequest = () => {
          $.ajax(opts)
              .then(() => {
                isSending = false;
                $form.removeClass('opt-out');
                $checkbox.prop('disabled', false);
              })
              .fail((xhr, status) => {
                // if timeout, try resending until success or reaching the retry limit
                if (status === 'timeout') {
                  if (retryCount < RETRY_LIMIT) {
                    retryCount++;
                    trackTimeout('retry');
                    sendRequest();
                  } else {
                    showTimeoutErrorModal();
                    trackTimeout('limit reached');
                    revertForm();
                  }
                  // other errors (404, 500, etc), show the normal error modal
                } else {
                  errorModalHandler(xhr);
                  revertForm();
                }
              });
        };
        sendRequest();
      });
    });
  });
};

/**
 * Controller.
 * @param {JQuery} $container
 */
account.paymentHistory = ($container) => {
    jqGetElemById('view-receipts').on('click', (e) => {
        e.preventDefault();
        const $element = $(e.currentTarget);

        $container.toggleClass('expanded');
        if ($container.hasClass('expanded')) {
            $element.removeClass('view-receipts');
            $element.addClass('hide-receipts');
        } else {
            $element.removeClass('hide-receipts');
            $element.addClass('view-receipts');
        }
    });
};


/**
 * Controller
 * @param $form
 */
account.deactivateAccountForm = function ($form) {
    var $checkboxes = $form.find(':checkbox');
    var $otherCheckbox = $checkboxes.filter('[value="other"]');
    var $otherField = $form.find('.other-text');
    var $otherTextarea = $otherField.find('textarea');
    var $secondStep = $form.find('.second-step');
    var $deactivateMethod = $form.find('[name="deactivate_method"]');
    var $tempDeactivateNotes = $form.find('.how-to-reactivate');
    var $passwordField = $form.find('.password');
    var $submit = $form.find('.btn-submit');

    var toggleOtherText = function() {
        $otherField.toggleClass('hide', !$otherCheckbox.prop('checked'));
    };

    var toggleSecondStep = function() {
        var numReasons = $checkboxes.filter(':checked').length;
        var hide = (numReasons === 0 ||
                    numReasons === 1 && $otherCheckbox.prop('checked') && $otherTextarea.val().trim() === '');
        $secondStep.toggleClass('hide', hide);
    };

    var toggleDeactivateMethod = function() {
        var deactivateMethod = $deactivateMethod.filter(':checked').val();
        $tempDeactivateNotes.toggleClass('hide', (deactivateMethod !== 'temporary'));
        $passwordField.toggleClass('hide', (deactivateMethod !== 'permanent'));
        if (deactivateMethod) {
            $submit.removeClass('hide');
        }
    };

    $checkboxes.on('change', function() {
        toggleSecondStep();
        if (this.value === 'other') {
            toggleOtherText();
        }
    });

    $otherTextarea.on('change click keyup', toggleSecondStep);
    $deactivateMethod.on('change', toggleDeactivateMethod);

    toggleOtherText();
    toggleSecondStep();
    toggleDeactivateMethod();

    $form.on('submit', function() {
        $submit.addClass('disabled').prop('disabled', true);
    });

    if ($form.find('.errorlist').length) {
        Anchors.scrollToTarget($form);
    }
};


/**
 * Custom upload avatar field controller.
 * @param {JQuery} $form
 */
account.uploadAvatarFormDesktop = ($form) => {
    const $uploadAvatarField = $form.find('.upload-avatar-field');
    const $input = $uploadAvatarField.find('input');
    const $filename = $uploadAvatarField.find('.filename');
    const $submitBtn = $form.find('.btn-submit');

    $filename.data('defaultValue', $filename.text());

    $input.on('change', () => {
        const newValue = $input.val();
        $filename.text(newValue ? newValue.replace(/^.*[\\/]/, '') : $filename.data('defaultValue'));
        $submitBtn.prop('disabled', !newValue);
    });
};


/**
 * Custom upload avatar field controller.
 * @param {JQuery} $container
 */
account.changeAvatarMobile = ($container) => {
    const $avatarWrapper = $container.find('.avatar-wrapper');
    const $uploadAvatarForm = $container.find('.upload-avatar-form');
    const $uploadAvatarField = $container.find('.upload-avatar-link input');
    const $chooseAvatarForm = $container.find('.choose-avatar-form');
    const $radioButtons = $chooseAvatarForm.find('input[type="radio"]');

    $uploadAvatarField.on('change', () => {
        if ($uploadAvatarField.val()) {
            $avatarWrapper.addClass(CLASS_NAME_LOADING);
            $uploadAvatarForm.submit();
        }
    });

    $radioButtons.on('change', (e) => {
        const radioButton = e.target;
        $radioButtons.prop('disabled', true);
        // since the radiobuttons are disabled now, the value won't make it into POST values,
        // so adding a hidden field with the same name and value
        jqCreateElem('input').attr({
            type: 'hidden',
            name: radioButton.name,
            value: radioButton.value,
        }).insertAfter(radioButton);
        $chooseAvatarForm.submit();
    });
};


/** @param {JQuery} $form */
account.deleteAvatarForm = ($form) => {
    const $checkboxes = $form.find('input[type="checkbox"]');
    const $btn = $form.find('.btn');

    $checkboxes.on('change', () => {
        $btn.prop('disabled', $checkboxes.filter(':checked').length === 0);
    });
};


/**
 * Controller.
 * Shows modal for B2 users when clicking the deactivation button.
 * @param {JQuery} $modal
 */
account.b2DeactivationModal = ($modal) => {
    jqGetElemById('deactivate-modal-trigger').on('click', () => {
        $modal.modal('show');
    });
};


/**
 * Poll the export state once the export has started,
 * display url once export is ready
 * @param {JQuery} $element
 */
account.pollExportState = function ($element) {
    const minute = 60 * 1000;
    const url = $element.data('url');

    const poll = () => {
        $.get(url)
            .then(function (response) {
                if (response.state === 'ready' && 'url' in response) {
                    $('.download').removeClass('hidden')
                        .find('a').attr('href',response.url);
                    $element.addClass('hidden');
                } else {
                    setTimeout(poll, minute);
                }
            });
    };
    poll();

    //this is test js for local dev which doesn't have analytics webhooks setup
    if ($element.attr('data-test-url')) {
        let testFinishState = () => {
            const testUrl = $element.data('test-url');
            setTimeout(() => {
                $.get(testUrl);
            }, .1 * minute);
        }
        testFinishState();
    }
}

module.exports = account;
